<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="button.params.fab ? button.params.fab : false"
						:icon="button.params.fab ? false : true"
						:small="button.params.small ? true : false"
						:fixed="button.params.fixed ? true : false"
						:bottom="button.params.bottom ? true : false"
						:right="button.params.right ? true : false"
						:dark="button.params.dark ? true : false"
						:color="button.params.button_color ? button.params.button_color : ''"
						@click="openDialog()">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ button.params.icon ? button.params.icon : 'mdi-magnify' }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ button.params.tooltip ? button.params.tooltip : 'Anteprima PDF' }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
			dense 
			:disabled="disabled"
			@click.stop="openDialog()"
			ripple>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ button.params.icon ? button.params.icon : 'mdi-magnify' }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ button.params.tooltip ? button.params.tooltip : 'Anteprima PDF' }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<v-dialog
			v-model="dialog"
			fullscreen
			ref="pdfPreview"
			hide-overlay
			eager>
			<v-card tile style="height: 100%; display: flex; flex-direction: column; padding-top: env(safe-area-inset-top);">
				<v-card-title class="pa-3 flex-shrink-0">
					<p class="pl-2 pl-xl-3">{{ button.params.tooltip ? button.params.tooltip : 'Anteprima PDF' }}</p>
					<v-spacer></v-spacer>
					<v-btn icon @click.native.stop="dialog = !dialog"><v-icon>close</v-icon></v-btn>
				</v-card-title>
				<v-divider class="flex-shrink-0"></v-divider>

				<object style="width:100%; flex: 1; min-height: 0;" v-if="pdfData" :data="pdfData" type="application/pdf"></object>

				<v-divider class="flex-shrink-0"></v-divider>

				<v-card-actions class="flex-shrink-0" style="padding-bottom: calc(16px + env(safe-area-inset-bottom));">
					<v-spacer></v-spacer>
					<v-btn @click="dialog = !dialog" color="red" text>Chiudi</v-btn>
					<v-btn @click="downloadPdf()" color="primary" text>Scarica</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import capacitorService from '@/services/capacitor-service'

export default {
    name: 'pdf-preview-dialog',
	props: {
		button: Object,
		buttonComponent: {type: String, default : 'v-btn'},
		id: Number,
		model: Object,
		modelDef: String,
		info: Object,
		params: Object,
		disabled: Boolean
	},

	data() {
		return {
			dialog: false,
            loading: false,
			pdfData: null,
			pdfBlob: null
		}
	},

	computed: {
		filename() {
			// Costruisce un nome file come nel download: $trans(info.model_name) + ' - ' + model.number
			let name = ''

			// Usa info.model_name se disponibile (come nel download)
			if (this.info?.model_name) {
				name = this.$trans(this.info.model_name)
			} else if (this.button?.params?.tooltip) {
				name = this.button.params.tooltip.replace('Anteprima ', '')
			} else {
				name = 'Documento'
			}

			// Aggiunge il numero del documento se disponibile
			if (this.model?.number) {
				name += ' - ' + this.model.number
			}

			return name + '.pdf'
		}
	},

	methods: {

		downloadPdf() {
			// Su Capacitor, usa il metodo nativo
			if (capacitorService.isNative && this.pdfBlob) {
				this.$eventBusUtility.saveCapacitorFile(this.pdfBlob, this.filename)
				return
			}

			var link = document.createElement('a')
          	link.href = this.pdfData
          	link.setAttribute("target", "_blank")
          	link.download=this.filename
          	link.click()
		},

		openPdfInNewWindow() {
			if (this.pdfData) {
				window.open(this.pdfData, '_blank'); // Apre il PDF in una nuova scheda
			}
		},

		async getPdfData() {
			if(this.pdfData != null) {
				return this.pdfData
			}

			let options = {
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
					'Authorization': 'Bearer ' + this.$store.getters.token
				},
				method: 'GET'
			}
			const response = await fetch(this.$store.getters.baseUrl+'/api/'+this.button.params.url + '/' + this.id + '/print', options)
			const blob = await response.blob()
			// It is necessary to create a new blob object with mime-type explicitly set
			// otherwise only Chrome works like it should
			const newBlob = new Blob([blob], {type: blob.type})

			// Salva il blob per uso su Capacitor
			this.pdfBlob = newBlob

			this.pdfData = window.URL.createObjectURL(newBlob)
			setTimeout(function(){
				// For Firefox it is necessary to delay revoking the ObjectURL
				window.URL.revokeObjectURL(this.pdfData)
			}, 100)
			return this.pdfData
		},

		async openDialog() {
			await this.getPdfData()

			// Su Capacitor nativo, apri direttamente con app PDF
			if (capacitorService.isNative) {
				this.$eventBusUtility.saveCapacitorFile(this.pdfBlob, this.filename)
				return
			}

			// Rileva se siamo su mobile (Android o iOS)
			const isAndroid = navigator.userAgent.match(/Android/i)
			const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
			const isMobile = isAndroid || isIOS

			if (isMobile) {
				// Su mobile apriamo il PDF in una nuova scheda per permettere zoom nativo
				this.openPdfInNewWindow()
			} else {
				this.dialog = true
				this.$eventBusUtility.$emit('showButtonsList', !this.dialog)
			}
		},

	},
}
</script>

<style>

</style>
